import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import {observer, inject} from 'mobx-react'
import {deepClone} from '@src/utils';
import OrderItem from '@componentsG/orderItem'
import ScrollC from '@components/scroll'
import {FormattedMessage} from 'react-intl'
import NoInfo from '@componentsG/noInfo'

@inject('orderListStore')
@observer
class MyOrder extends ComponentExt<any> {
    private store: any
    private readonly userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    private commonField = [
        {keyName: '内容', messageId: 'order.item.content', fieldName: 'content'},
        {keyName: '订单类型', messageId: 'order.item.orderType', fieldName: 'orderSubType'},
        {keyName: '有效期', messageId: 'order.item.validity', fieldName: 'validity'}
    ]

    private priceField = [
        {keyName: '小计', messageId: 'order.item.subTotal', fieldName: 'subTotal'},
        {keyName: '税', messageId: 'order.item.vat', fieldName: 'vatPrice'},
        {keyName: '总价', messageId: 'order.item.totalFee', fieldName: 'totalFee'}
    ]

    constructor(props) {
        super(props)
        this.store = props.orderListStore
    }

    async componentDidMount() {
        this.showLoading()
        await this.store.getOrderList(this.userInfo.iccid)
        this.hideLoading()
    }

    componentWillUnmount() {
        this.store.reStoreCurrent()
        this.store.setLock(false)
    }

    formatFieldList = dto => {
        return dto.totalFee > 0 ? [...this.commonField, ...this.priceField] : this.commonField
    }

    handleScroll = async () => {
        this.showLoading()
        this.store.setCurrent()
        await this.store.getOrderList(this.userInfo.iccid)
        this.hideLoading()
    }

    render() {
        const orderList = deepClone(this.store.orderList) || []
        return (
            <>
                {
                    orderList.length === 0 ?
                        <NoInfo
                            messageId="order.noInfo.message"
                            btnTextMessageId="order.noInfo.btnText"
                            handleClick={() => location.href = '#/global/home'}
                        />
                        :
                        <ScrollC
                            handleScroll={this.handleScroll}
                            loadingText={
                                <FormattedMessage id={!this.store.lock ? 'common.loading' : 'common.loading.noMore'}/>
                            }
                        >
                            {
                                orderList.map(item => (
                                    <OrderItem key={item.orderId} dto={item} fieldList={this.formatFieldList(item)}/>
                                ))
                            }
                        </ScrollC>
                }
            </>
        )
    }
}

export default MyOrder
